module.exports = require("./pt-CH.js");